import { Typography } from '@mui/material';
import { capitalizeFirstLetter, formatDistance } from 'features/common/utils';
import React from 'react';
import { useAppSelector } from 'state/hooks';
import { selectCurrentProjectInfo } from 'state/workflowSlice';
import styles from './RouteRow.module.css';

interface RSProps {
  route_length: number;
  cardinal_direction: string;
}

export function RouteSignature({ route_length, cardinal_direction }: RSProps) {
  const userProject = useAppSelector(selectCurrentProjectInfo);
  const direction = cardinal_direction
    ? capitalizeFirstLetter(cardinal_direction)
    : 'Unknown';

  return (
    <Typography
      variant="caption"
      className={styles.route_signature}
      sx={{
        visibility:
          route_length === undefined || cardinal_direction === undefined
            ? 'hidden'
            : 'visible',
      }}
    >
      {formatDistance(route_length, userProject.uses_metric)} | {direction}{' '}
      Direction
    </Typography>
  );
}
